export const PERMS = {
    READ: 'report_cost_center_traffic.read',
    UPDATE: 'report_cost_center_traffic.update',
    DELETE: 'report_cost_center_traffic.delete',
    CREATE: 'report_cost_center_traffic.create',
    EXPORT: 'report_cost_center_traffic.export',
}
